'use strict';

require('./build/buildDateRangeUnitsCall');

// This package does not export anything as it is
// simply defining "seconds" on Range.prototype.


//////////////////
// WEBPACK FOOTER
// ./~/sugar/range/seconds.js
// module id = 867
// module chunks = 0